export { default as VariablePage } from './variable'
export { default as SettingPage } from './setting'
export { default as SettingDetailPage } from './setting/detail'
export { default as PaySuccessPage } from './paySuccess'
export { default as BoxSystemPage } from './boxSystem'
export { default as MemberPage } from './member'
export { default as ArticlePage } from './article'
export { default as DemoPage } from './demo'
export { default as FavoritePage } from './favorite'
export { default as DashboardPage } from './dashboard'
export { default as SetModulePage } from './setModule'
export { default as ErrorPage } from './error'
export { default as GuidePage } from './guide'